const ATTRIBUTE_PATH = 'attributes.';
const ATTRIBUTE_EXPRESSION = '$';

/**
 * The attribute a catalogue key names, or nothing when the key is a property of the entity itself.
 *
 * @param {String} key - A catalogue key.
 *
 * @returns {String|null}
 */
export const attributeName = (key) =>
  key?.startsWith(ATTRIBUTE_PATH) ? key.slice(ATTRIBUTE_PATH.length) : null;

/** The surfaces whose keys are sent to the server as expression names rather than read as paths. */
export const EXPRESSION_SURFACES = ['filters', 'sorting'];

/** Whether a surface names its keys the way the server reads them. */
const isExpressionSurface = (surface) => EXPRESSION_SURFACES.includes(surface);

/**
 * A catalogue key in the dialect of a surface.
 *
 * The rendering surfaces read a value path into the row, so they take the key as it comes. Filters
 * and sorting send an expression name, where an attribute carries a leading `$`.
 *
 * @param {String} key - A catalogue key.
 * @param {String} surface - list, detail, filters or sorting.
 *
 * @returns {String}
 */
export const surfaceKey = (key, surface) =>
  isExpressionSurface(surface) && key?.startsWith(ATTRIBUTE_PATH)
    ? `${ATTRIBUTE_EXPRESSION}${key.slice(ATTRIBUTE_PATH.length)}`
    : key;

/**
 * The catalogue key a layout entry's key came from, for looking the entry back up.
 *
 * @param {String} key - A layout entry's key.
 * @param {String} surface - list, detail, filters or sorting.
 *
 * @returns {String}
 */
export const catalogueKey = (key, surface) =>
  isExpressionSurface(surface) && key?.startsWith(ATTRIBUTE_EXPRESSION)
    ? `${ATTRIBUTE_PATH}${key.slice(ATTRIBUTE_EXPRESSION.length)}`
    : key;
